
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { LocalAssetRequestService } from "../../../../shared/graphql/local-asset-requests.service";
import { TechProfilesListActions } from "./tech-profiles-list-actions";
import { TechProfilesListService } from "./tech-profiles-list-service";

@Injectable()
export class TechProfilesListEpics {

    constructor(private techProfilesListService: TechProfilesListService,
                private localAssetRequestService: LocalAssetRequestService) {}

    deleteTechProfilesEpic = (action$) => {
        return action$.ofType(TechProfilesListActions.DELETE_TECH_PROFILES)
            .switchMap((action) => {
                return this.techProfilesListService.deleteTechProfiles(action.payload).pipe(
                    map(() => {
                        return {type: TechProfilesListActions.GET_TECH_PROFILES_LIST, payload: action.payload.clientId};
                    }))
            });
    };

    getTechProfilesListEpic = (action$) => {
        return action$.ofType(TechProfilesListActions.GET_TECH_PROFILES_LIST)
            .switchMap((action) => {
                return this.techProfilesListService.getClientTechProfilesList(action.payload).pipe(
                    map((response) => {
                        return {type: TechProfilesListActions.GET_TECH_PROFILES_LIST_SUCCESS, payload: response};
                    }))
            });
    };

    getTechProfilesAppliesToFilterListEpic = (action$) => {
        return action$.ofType(TechProfilesListActions.GET_TECH_PROFILES_APPLIES_TO_LIST)
            .switchMap(() => this.localAssetRequestService.getJsonFile("/assets/data/client/tech-profile-servicing-filters.json").pipe(
                map((response) => {
                    return { type: "GET_TECH_PROFILES_APPLIES_TO_LIST_SUCCESS", payload: response.data };
                })),
            );

    };

}
